import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import { LoadingIndicator } from 'components/LoadingIndicator';

type MicButtonProps = {
  isTranscriptInitializationInProgress: boolean;
  micButtonMuted: boolean;
  setMicButtonMuted: (value: boolean) => void; // Assuming this is a function to update the state
};

const StyledMicrophone = styled(IconButton)(
  () => `
  border-radius: 100px;
  gap: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`,
);

export const OpenEndedMicButton = ({
  isTranscriptInitializationInProgress,
  micButtonMuted,
  setMicButtonMuted,
}: MicButtonProps) => {
  const micButtonMutedComponent: React.JSX.Element = (
    <Tooltip key='audio' placement='bottom' title='Click to mute'>
      <StyledMicrophone
        data-testid='microphone-input'
        sx={{
          backgroundColor: 'success.main',
          color: 'success.contrastText',
          '&:hover': {
            backgroundColor: 'success.dark',
            color: 'success.contrastText',
          },
        }}
        aria-label='Microphone On'
        onClick={() => setMicButtonMuted(true)}
      >
        <MicIcon />
      </StyledMicrophone>
    </Tooltip>
  );

  const micButtonUnmutedComponent: React.JSX.Element = (
    <Tooltip key='audio' placement='bottom' title='Click to unmute'>
      <StyledMicrophone
        data-testid='microphone-input'
        sx={{
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          '&:hover': {
            backgroundColor: 'primary.dark',
            color: 'primary.contrastText',
          },
        }}
        aria-label='Microphone Off'
        onClick={() => setMicButtonMuted(false)}
      >
        <MicOffIcon />
      </StyledMicrophone>
    </Tooltip>
  );

  if (!isTranscriptInitializationInProgress) return <LoadingIndicator />;
  if (!micButtonMuted) return micButtonMutedComponent;
  return micButtonUnmutedComponent;
};
